import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import NumerologyPage from "./pages/NumerologyPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import ContactUs from "./pages/ContactUs";
import InfoPage from "./pages/InfoPage";
import { ScrollToTop } from "./components/ScrollToTop"; // ⬅️ tambahkan ini

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* ⬇️ letakkan ScrollToTop di dalam BrowserRouter */}
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/numerology" element={<NumerologyPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/info" element={<InfoPage />} />
          {/* Alias routes */}
          <Route path="/about" element={<InfoPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
